import React, { useState, memo } from 'react';
import { TRANSLATIONS } from '../../../../translations';

import SearchHistory from '../../../hooks/interactsWithSearchHistory';
import Button, { ButtonSizes, ButtonStyles } from '../../Button/Button';
import Typography, {
  TypographyWeights,
} from '../../../ui-components/Typography/Typography';
import Image, { ImageSizes } from '../../../ui-components/Image/Image';
import Carousel from '../../../ui-components/Carousel/Carousel';

function SmartSearchHistory() {
  const [history, setHistory] = useState(SearchHistory.read());

  const searchIcon = (
    <Image
      source="https://cdn.freedome.it/icons/magnifying-glass.svg"
      size={ImageSizes.xsmall}
      alt="Magnifying glass"
    />
  );

  const historyChips = history?.map((item, index) => (
    <Button
      key={index}
      label={<Typography variant="p3">{item.title}</Typography>}
      style={ButtonStyles.chipSuggestion}
      size={ButtonSizes.xs}
      onClick={() => (window.location.href = item.url)}
    />
  ));

  const handleClear = () => {
    setHistory([]);
    SearchHistory.clear();
  };

  return (
    history.length > 0 && (
      <div className="d-flex flex-column gap-base">
        <div className="d-flex justify-between items-center pt-xs">
          <div className="d-flex gap-base items-center">
            {searchIcon}
            <Typography variant="p2" weight={TypographyWeights['semi-bold']}>
              {TRANSLATIONS.RECENT_SEARCHES}
            </Typography>
          </div>
          <Button
            label={TRANSLATIONS.DELETE_ALL}
            style={ButtonStyles.textDestructive}
            size={ButtonSizes.xs}
            iconLeft={
              <Image
                source="https://cdn.freedome.it/icons/bin-red.svg"
                size={ImageSizes.original}
                alt="Bin"
              />
            }
            onClick={handleClear}
          />
        </div>
        {history && history.length !== 0 && (
          <Carousel classNames="gap-base gap-xs pb-m">{historyChips}</Carousel>
        )}
      </div>
    )
  );
}

export default memo(SmartSearchHistory);
